export interface MonthlyTransactionDto {
	month: number;
	totalAmount: number;
}
